exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".landing-image-text .valentine{font-size:26px;font-size:1.625rem}", ""]);

